import React, { PureComponent } from "react";

import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import paginationFactory from "react-bootstrap-table2-paginator";
import {
  selectFormat,
  sortNumeric,
  Error,
  getMetricForColumn,
} from "components/Utils/Utils.js";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";

class LeeSubscriptionsByMarket extends PureComponent {
  componentDidMount() {
    this.props.childRef(this);
  }

  headerFormatter(column, colIndex, index, firstRow) {
    const normalColumn = ["installs"].includes(column.dataField);
    return (
      <>
        <div
          style={{
            backgroundColor: normalColumn ? "" : "#adb5bd",
            color: normalColumn ? "" : "#fff",
            padding: "5px",
          }}
        >
          {index === 1 && (
            <div
              style={{
                fontSize: "13px",
                textTransform: "uppercase",
                fontFamily: "Museo Slab W01",
                fontWeight: "bold",
              }}
            >
              Total
            </div>
          )}
          {column.text}
        </div>
      </>
    );
  }

  renderTable(data) {
    const { title } = this.props;

    // add unique ids
    data.forEach((d, i) => (d.id = i));

    const groupedColumns = [];

    const firstRow = data[0];

    const firstElement = { ...data[0] };
    delete firstElement.market;
    delete firstElement.installs;
    delete firstElement.uninstalls;
    delete firstElement.activations;
    delete firstElement.cancellations;

    Object.keys(firstElement).forEach((key, index) => {
      Object.keys(firstElement[key]).forEach((fKey) => {
        groupedColumns.push({
          dataField: key + "." + fKey,
          text: fKey,
          style: {
            width: "110px",
            minWidth: "110px",
            textAlign: "left",
            backgroundColor: "#f2f2f2",
          },
          headerAlign: "left",
          align: "center",
          formatter: (cell) => selectFormat("number", cell && cell, "0,0"),
          headerFormatter: (column, colIndex) =>
            this.headerFormatter(column, colIndex, index, firstRow),
          sort: true,
        });
      });
    });
    const columns = [
      {
        dataField: "market",
        text: "Market",
        style: { width: "150px", minWidth: "150px", textAlign: "left" },
        headerAlign: "left",
        sort: true,
        filter: textFilter({
          getFilter: (filter) => filter,
          placeholder: " ",
          className: "custom-table-filter-input",
          caseSensitive: false,
        }),
      },
      {
        dataField: "total_subs",
        text: "Total Subs",
        style: {
          width: "110px",
          minWidth: "110px",
          textAlign: "left",
          backgroundColor: "#f2f2f2",
          padding: "12px",
        },
        headerAlign: "left",
        align: "center",
        headerFormatter: (column, colIndex) =>
          this.headerFormatter(column, colIndex, 1, firstRow),
        sort: true,
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sortFunc: sortNumeric,
      },
      {
        dataField: "change",
        text: "Change",
        formatter: (cell) => selectFormat("number", cell.value, "0,0"),
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,

        style: {
          width: "80px",
          minWidth: "80px",
          textAlign: "center",
          backgroundColor: "#f2f2f2",
        },
        headerAlign: "left",
        align: "center",
        headerFormatter: (column, colIndex) =>
          this.headerFormatter(column, colIndex, 2, firstRow),
      },
      {
        dataField: "apple_subs",
        text: "Apple",
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
        style: {
          width: "110px",
          minWidth: "110px",
          textAlign: "left",
          backgroundColor: "#f2f2f2",
          padding: "12px",
        },
        headerAlign: "left",
        align: "center",
        headerFormatter: (column, colIndex) =>
          this.headerFormatter(column, colIndex, 3, firstRow),
      },
      {
        dataField: "apple_subs_pct",
        text: "% of Total",
        formatExtraData: { type: "percentage" },
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,000%"),
        sortFunc: sortNumeric,

        style: {
          width: "80px",
          minWidth: "80px",
          textAlign: "left",
          backgroundColor: "#f2f2f2",
        },
        headerAlign: "left",
        align: "center",
        formatter: (cell) => selectFormat("percentage", cell.value),

        headerFormatter: (column, colIndex) =>
          this.headerFormatter(column, colIndex, 4, firstRow),
        sort: true,
      },
      {
        dataField: "google_subs",
        text: "Google",
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,

        style: {
          width: "110px",
          minWidth: "110px",
          textAlign: "left",
          backgroundColor: "#f2f2f2",
          padding: "12px",
        },
        headerAlign: "left",
        align: "center",
        headerFormatter: (column, colIndex) =>
          this.headerFormatter(column, colIndex, 5, firstRow),
      },
      {
        dataField: "google_subs_pct",
        text: "% of Total",
        formatter: (cell) => selectFormat("percentage", cell.value),

        formatExtraData: { type: "percentage" },
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,000%"),
        sort: true,
        sortFunc: sortNumeric,
        style: {
          width: "70px",
          minWidth: "70px",
          textAlign: "left",
          backgroundColor: "#f2f2f2",
        },
        headerAlign: "left",
        align: "center",
        headerFormatter: (column, colIndex) =>
          this.headerFormatter(column, colIndex, 6, firstRow),
      },
      {
        dataField: "installs",
        text: "Installs",
        style: { width: "110px", minWidth: "110px", padding: "12px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        headerFormatter: (column, colIndex) =>
          this.headerFormatter(column, colIndex, colIndex, firstRow),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "uninstalls",
        text: "Uninstalls",
        style: { width: "110px", minWidth: "110px", padding: "12px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "activations",
        text: "Activations",
        style: { width: "110px", minWidth: "110px", padding: "12px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "cancellations",
        text: "Cancellations",
        style: { width: "110px", minWidth: "110px", padding: "12px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
    ];

    const pagination = paginationFactory({
      sizePerPage: 20,
      hideSizePerPage: true,
    });

    const defaultSorted = [
      {
        dataField: "paying_subscriptions",
        order: "desc",
      },
    ];

    const filename = title.split(" ").join("_") || "spreadsheet";

    return (
      <div className="table-grouped-headers">
        <ToolkitProvider
          keyField="id"
          data={data}
          columns={columns}
          striped={false}
          hover={false}
          bordered={false}
          exportCSV={{
            fileName: filename + ".csv",
            exportAll: true,
            onlyExportFiltered: true,
          }}
        >
          {(props) => (
            <BootstrapTable
              {...props.baseProps}
              {...props.csvProps}
              pagination={pagination}
              defaultSorted={defaultSorted}
              footerClasses={"tfoot__tr"}
              filter={filterFactory()}
              ref={(el) => (this.childRef = el)}
            />
          )}
        </ToolkitProvider>
      </div>
    );
  }

  builtInExportCSV = () => this.childRef;

  render() {
    const { data } = this.props;

    if (data.hasData === false) {
      return <Error minHeight={360} />;
    }

    return this.renderTable(data.data);
  }
}

export default LeeSubscriptionsByMarket;
